<GlobalNav backPath="/" />

<div class="section is-fullheight">
  <div class="container">
    <div class="column is-8-desktop is-10-tablet">
      <div class="box mt-5 content">
        <h1>Datenschutzerkl&auml;rung</h1>

        <h2>
          1) Information &uuml;ber die Erhebung personenbezogener Daten und
          Kontaktdaten des Verantwortlichen
        </h2>

        <p>
          <b>1.1</b>&thinsp;Wir freuen uns, dass Sie unsere Website besuchen und
          bedanken uns f&uuml;r Ihr Interesse. Im Folgenden informieren wir Sie
          &uuml;ber den Umgang mit Ihren personenbezogenen Daten bei der Nutzung
          unserer Website. Personenbezogene Daten sind hierbei alle Daten, mit
          denen Sie pers&ouml;nlich identifiziert werden k&ouml;nnen.
        </p>

        <p>
          <b>1.2</b>&thinsp;Verantwortlicher f&uuml;r die Datenverarbeitung auf
          dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist
          BE/GOLF. GbR, Friedenstra&szlig;e 4, 86441 Zusmarshausen, Deutschland,
          Tel.: 0151 22947734, E-Mail: mail@be-golf.com. Der f&uuml;r die
          Verarbeitung von personenbezogenen Daten Verantwortliche ist diejenige
          nat&uuml;rliche oder juristische Person, die allein oder gemeinsam mit
          anderen &uuml;ber die Zwecke und Mittel der Verarbeitung von
          personenbezogenen Daten entscheidet.
        </p>

        <p>
          <b>1.3</b>&thinsp;Diese Website nutzt aus Sicherheitsgr&uuml;nden und
          zum Schutz der &Uuml;bertragung personenbezogener Daten und anderer
          vertraulicher Inhalte (z.B. Bestellungen oder Anfragen an den
          Verantwortlichen) eine SSL-bzw. TLS-Verschl&uuml;sselung. Sie
          k&ouml;nnen eine verschl&uuml;sselte Verbindung an der Zeichenfolge
          &bdquo;https://&ldquo; und dem Schloss-Symbol in Ihrer Browserzeile
          erkennen.
        </p>

        <h2>2) Datenerfassung beim Besuch unserer Website</h2>

        <p>
          Bei der blo&szlig; informatorischen Nutzung unserer Website, also wenn
          Sie sich nicht registrieren oder uns anderweitig Informationen
          &uuml;bermitteln, erheben wir nur solche Daten, die Ihr Browser an
          unseren Server &uuml;bermittelt (sog. &bdquo;Server-Logfiles&ldquo;).
          Wenn Sie unsere Website aufrufen, erheben wir die folgenden Daten, die
          f&uuml;r uns technisch erforderlich sind, um Ihnen die Website
          anzuzeigen:
        </p>

        <ul>
          <li>Unsere besuchte Website</li>
          <li>Datum und Uhrzeit zum Zeitpunkt des Zugriffes</li>
          <li>Menge der gesendeten Daten in Byte</li>
          <li>Quelle/Verweis, von welchem Sie auf die Seite gelangten</li>
          <li>Verwendeter Browser</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Verwendete IP-Adresse (ggf.: in anonymisierter Form)</li>
        </ul>

        <p>
          Die Verarbeitung erfolgt gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO
          auf Basis unseres berechtigten Interesses an der Verbesserung der
          Stabilit&auml;t und Funktionalit&auml;t unserer Website. Eine
          Weitergabe oder anderweitige Verwendung der Daten findet nicht statt.
          Wir behalten uns allerdings vor, die Server-Logfiles nachtr&auml;glich
          zu &uuml;berpr&uuml;fen, sollten konkrete Anhaltspunkte auf eine
          rechtswidrige Nutzung hinweisen.
        </p>

        <h2>3) Cookies</h2>

        <p>
          Um den Besuch unserer Website attraktiv zu gestalten und die Nutzung
          bestimmter Funktionen zu erm&ouml;glichen, verwenden wir auf
          verschiedenen Seiten sogenannte Cookies. Hierbei handelt es sich um
          kleine Textdateien, die auf Ihrem Endger&auml;t abgelegt werden.
          Einige der von uns verwendeten Cookies werden nach dem Ende der
          Browser-Sitzung, also nach Schlie&szlig;en Ihres Browsers, wieder
          gel&ouml;scht (sog. Sitzungs-Cookies). Andere Cookies verbleiben auf
          Ihrem Endger&auml;t und erm&ouml;glichen, Ihren Browser beim
          n&auml;chsten Besuch wiederzuerkennen (sog. persistente Cookies).
          Werden Cookies gesetzt, erheben und verarbeiten diese im individuellen
          Umfang bestimmte Nutzerinformationen wie Browser- und Standortdaten
          sowie IP-Adresswerte. Persistente Cookies werden automatisiert nach
          einer vorgegebenen Dauer gel&ouml;scht, die sich je nach Cookie
          unterscheiden kann. Die Dauer der jeweiligen Cookie-Speicherung
          k&ouml;nnen Sie der &Uuml;bersicht zu den Cookie-Einstellungen Ihres
          Webbrowsers entnehmen.
        </p>

        <p>
          Teilweise dienen die Cookies dazu, durch Speicherung von Einstellungen
          den Bestellprozess zu vereinfachen (z.B. Merken des Inhalts eines
          virtuellen Warenkorbs f&uuml;r einen sp&auml;teren Besuch auf der
          Website). Sofern durch einzelne von uns eingesetzte Cookies auch
          personenbezogene Daten verarbeitet werden, erfolgt die Verarbeitung
          gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO entweder zur
          Durchf&uuml;hrung des Vertrages, gem&auml;&szlig; Art. 6 Abs. 1 lit. a
          DSGVO im Falle einer erteilten Einwilligung oder gem&auml;&szlig; Art.
          6 Abs. 1 lit. f DSGVO zur Wahrung unserer berechtigten Interessen an
          der bestm&ouml;glichen Funktionalit&auml;t der Website sowie einer
          kundenfreundlichen und effektiven Ausgestaltung des Seitenbesuchs.
        </p>

        <p>
          Bitte beachten Sie, dass Sie Ihren Browser so einstellen k&ouml;nnen,
          dass Sie &uuml;ber das Setzen von Cookies informiert werden und
          einzeln &uuml;ber deren Annahme entscheiden oder die Annahme von
          Cookies f&uuml;r bestimmte F&auml;lle oder generell ausschlie&szlig;en
          k&ouml;nnen. Jeder Browser unterscheidet sich in der Art, wie er die
          Cookie-Einstellungen verwaltet. Diese ist in dem Hilfemen&uuml; jedes
          Browsers beschrieben, welches Ihnen erl&auml;utert, wie Sie Ihre
          Cookie-Einstellungen &auml;ndern k&ouml;nnen. Diese finden Sie
          f&uuml;r die jeweiligen Browser unter den folgenden Links:
        </p>

        <p>
          Internet Explorer:
          https://support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies<br
          />
          Firefox:
          https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen<br />
          Chrome:
          https://support.google.com/chrome/answer/95647?hl=de&amp;hlrm=en<br />
          Safari: https://support.apple.com/de-de/guide/safari/sfri11471/mac<br
          />
          Opera: https://help.opera.com/de/latest/web-preferences/#cookies
        </p>

        <p>
          Bitte beachten Sie, dass bei Nichtannahme von Cookies die
          Funktionalit&auml;t unserer Website eingeschr&auml;nkt sein kann.
        </p>

        <h2>4) Kontaktaufnahme</h2>

        <p>
          Im Rahmen der Kontaktaufnahme mit uns (z.B. per Kontaktformular oder
          E-Mail) werden personenbezogene Daten erhoben. Welche Daten im Falle
          der Nutzung eines Kontaktformulars erhoben werden, ist aus dem
          jeweiligen Kontaktformular ersichtlich. Diese Daten werden
          ausschlie&szlig;lich zum Zweck der Beantwortung Ihres Anliegens bzw.
          f&uuml;r die Kontaktaufnahme und die damit verbundene technische
          Administration gespeichert und verwendet. Rechtsgrundlage f&uuml;r die
          Verarbeitung dieser Daten ist unser berechtigtes Interesse an der
          Beantwortung Ihres Anliegens gem&auml;&szlig; Art. 6 Abs. 1 lit. f
          DSGVO. Zielt Ihre Kontaktierung auf den Abschluss eines Vertrages ab,
          so ist zus&auml;tzliche Rechtsgrundlage f&uuml;r die Verarbeitung Art.
          6 Abs. 1 lit. b DSGVO. Ihre Daten werden nach abschlie&szlig;ender
          Bearbeitung Ihrer Anfrage gel&ouml;scht. Dies ist der Fall, wenn sich
          aus den Umst&auml;nden entnehmen l&auml;sst, dass der betroffene
          Sachverhalt abschlie&szlig;end gekl&auml;rt ist und sofern keine
          gesetzlichen Aufbewahrungspflichten entgegenstehen.
        </p>

        <h2>
          5) Datenverarbeitung bei Er&ouml;ffnung eines Kundenkontos und zur
          Vertragsabwicklung
        </h2>

        <p>
          Gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO werden personenbezogene
          Daten weiterhin erhoben und verarbeitet, wenn Sie uns diese zur
          Durchf&uuml;hrung eines Vertrages oder bei der Er&ouml;ffnung eines
          Kundenkontos mitteilen. Welche Daten erhoben werden, ist aus den
          jeweiligen Eingabeformularen ersichtlich. Eine L&ouml;schung Ihres
          Kundenkontos ist jederzeit m&ouml;glich und kann durch eine Nachricht
          an die o.g. Adresse des Verantwortlichen erfolgen. Wir speichern und
          verwenden die von Ihnen mitgeteilten Daten zur Vertragsabwicklung.
          Nach vollst&auml;ndiger Abwicklung des Vertrages oder L&ouml;schung
          Ihres Kundenkontos werden Ihre Daten mit R&uuml;cksicht auf steuer-
          und handelsrechtliche Aufbewahrungsfristen gesperrt und nach Ablauf
          dieser Fristen gel&ouml;scht, sofern Sie nicht ausdr&uuml;cklich in
          eine weitere Nutzung Ihrer Daten eingewilligt haben oder eine
          gesetzlich erlaubte weitere Datenverwendung von unserer Seite
          vorbehalten wurde.
        </p>

        <h2>6) Kommentarfunktion</h2>

        <p>
          Im Rahmen der Kommentarfunktion auf dieser Website werden neben Ihrem
          Kommentar auch Angaben zum Zeitpunkt der Erstellung des Kommentars und
          der von Ihnen gew&auml;hlte Kommentatorenname gespeichert und auf
          dieser Website ver&ouml;ffentlicht. Ferner wird Ihre IP-Adresse
          mitprotokolliert und gespeichert. Diese Speicherung der IP-Adresse
          erfolgt aus Sicherheitsgr&uuml;nden und f&uuml;r den Fall, dass die
          betroffene Person durch einen abgegebenen Kommentar die Rechte Dritter
          verletzt oder rechtswidrige Inhalte postet. Ihre E-Mailadresse
          ben&ouml;tigen wir, um mit Ihnen in Kontakt zu treten, falls ein
          Dritter Ihren ver&ouml;ffentlichten Inhalt als rechtswidrig
          beanstanden sollte. Rechtsgrundlagen f&uuml;r die Speicherung Ihrer
          Daten sind die Art. 6 Abs. 1 lit. b und f DSGVO. Wir behalten uns vor,
          Kommentare zu l&ouml;schen, wenn sie von Dritten als rechtswidrig
          beanstandet werden.
        </p>

        <p>
          Die Nachfolgekommentare k&ouml;nnen von Ihnen als Nutzer abonniert
          werden. Sie erhalten hierzu eine Best&auml;tigungs-E-Mail, damit
          sichergestellt werden kann, dass Sie der Inhaber der angegebenen
          E-Mail-Adresse sind (Double-Opt-In-Verfahren). Die Rechtsgrundlage
          f&uuml;r die Datenverarbeitung im Falle der Abonnierung von
          Kommentaren ist Art. 6 Abs. 1 lit. a DSGVO. Sie k&ouml;nnen laufende
          Kommentarabonnements jederzeit mit Wirkung f&uuml;r die Zukunft
          abbestellen, n&auml;here Informationen zur Abbestellm&ouml;glichkeit
          entnehmen Sie bitte der Best&auml;tigungs-E-Mail.
        </p>

        <h2>7) Nutzung von Kundendaten zur Direktwerbung</h2>

        <p><b>7.1</b>&thinsp;Anmeldung zu unserem E-Mail-Newsletter</p>

        <p>
          Wenn Sie sich zu unserem E-Mail Newsletter anmelden, &uuml;bersenden
          wir Ihnen regelm&auml;&szlig;ig Informationen zu unseren Angeboten.
          Pflichtangabe f&uuml;r die &Uuml;bersendung des Newsletters ist allein
          Ihre E-Mailadresse. Die Angabe weiterer Daten ist freiwillig und wird
          verwendet, um Sie pers&ouml;nlich ansprechen zu k&ouml;nnen. F&uuml;r
          den Versand des Newsletters verwenden wir das sog. Double Opt-in
          Verfahren. Dies bedeutet, dass wir Ihnen erst dann einen E-Mail
          Newsletter &uuml;bermitteln werden, wenn Sie uns ausdr&uuml;cklich
          best&auml;tigt haben, dass Sie in den Empfang von Newsletter
          einwilligen. Wir schicken Ihnen dann eine Best&auml;tigungs-E-Mail,
          mit der Sie gebeten werden durch Anklicken eines entsprechenden Links
          zu best&auml;tigen, dass Sie k&uuml;nftig den Newsletter erhalten
          wollen.
        </p>

        <p>
          Mit der Aktivierung des Best&auml;tigungslinks erteilen Sie uns Ihre
          Einwilligung f&uuml;r die Nutzung Ihrer personenbezogenen Daten
          gem&auml;&szlig; Art. 6 Abs. 1 lit. a DSGVO. Bei der Anmeldung zum
          Newsletter speichern wir Ihre vom Internet Service-Provider (ISP)
          eingetragene IP-Adresse sowie das Datum und die Uhrzeit der Anmeldung,
          um einen m&ouml;glichen Missbrauch Ihrer E-Mail- Adresse zu einem
          sp&auml;teren Zeitpunkt nachvollziehen zu k&ouml;nnen. Die von uns bei
          der Anmeldung zum Newsletter erhobenen Daten werden
          ausschlie&szlig;lich f&uuml;r Zwecke der werblichen Ansprache im Wege
          des Newsletters benutzt. Sie k&ouml;nnen den Newsletter jederzeit
          &uuml;ber den daf&uuml;r vorgesehenen Link im Newsletter oder durch
          entsprechende Nachricht an den eingangs genannten Verantwortlichen
          abbestellen. Nach erfolgter Abmeldung wird Ihre E-Mailadresse
          unverz&uuml;glich in unserem Newsletter-Verteiler gel&ouml;scht,
          soweit Sie nicht ausdr&uuml;cklich in eine weitere Nutzung Ihrer Daten
          eingewilligt haben oder wir uns eine dar&uuml;berhinausgehende
          Datenverwendung vorbehalten, die gesetzlich erlaubt ist und &uuml;ber
          die wir Sie in dieser Erkl&auml;rung informieren.
        </p>

        <p>
          <b>7.2</b>&thinsp;Versand des E-Mail-Newsletters an Bestandskunden
        </p>

        <p>
          Wenn Sie uns Ihre E-Mailadresse beim Kauf von Waren bzw.
          Dienstleistungen zur Verf&uuml;gung gestellt haben, behalten wir uns
          vor, Ihnen regelm&auml;&szlig;ig Angebote zu &auml;hnlichen Waren bzw.
          Dienstleistungen, wie den bereits gekauften, aus unserem Sortiment per
          E-Mail zuzusenden. Hierf&uuml;r m&uuml;ssen wir gem&auml;&szlig;
          &sect; 7 Abs. 3 UWG keine gesonderte Einwilligung von Ihnen einholen.
          Die Datenverarbeitung erfolgt insoweit allein auf Basis unseres
          berechtigten Interesses an personalisierter Direktwerbung
          gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO. Haben Sie der Nutzung
          Ihrer E-Mailadresse zu diesem Zweck anf&auml;nglich widersprochen,
          findet ein Mailversand unsererseits nicht statt. Sie sind berechtigt,
          der Nutzung Ihrer E-Mailadresse zu dem vorbezeichneten Werbezweck
          jederzeit mit Wirkung f&uuml;r die Zukunft durch eine Mitteilung an
          den zu Beginn genannten Verantwortlichen zu widersprechen.
          Hierf&uuml;r fallen f&uuml;r Sie lediglich &Uuml;bermittlungskosten
          nach den Basistarifen an. Nach Eingang Ihres Widerspruchs wird die
          Nutzung Ihrer E-Mailadresse zu Werbezwecken unverz&uuml;glich
          eingestellt.
        </p>

        <p><b>7.3</b>&thinsp;WhatsApp-Newsletter</p>

        <p>
          Wenn Sie sich zu unserem WhatsApp-Newsletter anmelden, &uuml;bersenden
          wir Ihnen regelm&auml;&szlig;ig Informationen zu unseren Angeboten per
          WhatsApp. Pflichtangabe f&uuml;r die &Uuml;bersendung des Newsletters
          ist allein Ihre Mobilfunknummer.
        </p>

        <p>
          F&uuml;r den Versand des Newsletters nehmen Sie unsere mitgeteilte
          Mobilfunknummer in die Adress-Kontakte Ihres Mobilfunkger&auml;ts auf
          und senden uns die Nachricht &bdquo;Start&ldquo; per WhatsApp. Mit der
          &Uuml;bersendung dieser WhatsApp-Nachricht erteilen Sie uns Ihre
          Einwilligung f&uuml;r die Nutzung Ihrer personenbezogenen Daten
          gem&auml;&szlig; Art. 6 Abs. 1 lit. a DSGVO zum Zwecke der
          Newslette&uuml;bersendung. Wir nehmen Sie sodann in unseren
          Newsletter-Verteiler auf.
        </p>

        <p>
          Die von uns bei der Anmeldung zum Newsletter erhobenen Daten werden
          ausschlie&szlig;lich f&uuml;r Zwecke der werblichen Ansprache im Wege
          des Newsletters verarbeitet. Sie k&ouml;nnen jederzeit den Newsletter
          abmelden, indem Sie uns die Nachricht &bdquo;Stop&ldquo; per WhatsApp
          senden. Nach erfolgter Abmeldung wird Ihre Mobilfunknummer
          unverz&uuml;glich in unserem Newsletter-Verteiler gel&ouml;scht,
          soweit Sie nicht ausdr&uuml;cklich in eine weitere Nutzung Ihrer Daten
          eingewilligt haben oder wir uns eine dar&uuml;berhinausgehende
          Datenverwendung vorbehalten, die gesetzlich erlaubt ist und &uuml;ber
          die wir Sie in dieser Erkl&auml;rung informieren.
        </p>

        <p>
          Bitte beachten Sie, dass WhatsApp Zugriff auf das Adressbuch des von
          uns f&uuml;r den Newsletterversand verwendeten mobilen Endger&auml;ts
          erh&auml;lt und im Adressbuch gespeicherte Telefonnummern automatisch
          an einen Server von Facebook in den USA &uuml;bertr&auml;gt.
        </p>

        <p>
          F&uuml;r den Versand unseres WhatsApp-Newsletters verwenden wir daher
          ein mobiles Endger&auml;t, in dessen Adressbuch ausschlie&szlig;lich
          die WhatsApp-Kontaktdaten unserer Newsletter-Empf&auml;nger
          gespeichert werden. Hierdurch wird sichergestellt, dass jede Person,
          deren WhatsApp- Kontaktdaten in unserem Adressbuch gespeichert sind,
          bereits bei erstmaliger Nutzung der App auf seinem Ger&auml;t durch
          Akzeptanz der WhatsApp-Nutzungsbedingungen in die &Uuml;bermittlung
          seiner WhatsApp-Telefonnummer aus den Adressb&uuml;chern seiner
          Chat-Kontakte gem&auml;&szlig; Art. 6 Abs. 1 lit. a DSGVO eingewilligt
          hat. Eine &Uuml;bermittlung von Daten solcher Nutzer, die WhatsApp
          nicht verwenden und/oder uns nicht &uuml;ber WhatsApp kontaktiert
          haben, wird insofern ausgeschlossen.
        </p>

        <p>
          Zweck und Umfang der Datenerhebung und die weitere Verarbeitung und
          Nutzung der Daten durch WhatsApp sowie Ihre diesbez&uuml;glichen
          Rechte und Einstellungsm&ouml;glichkeiten zum Schutz Ihrer
          Privatsph&auml;re entnehmen Sie bitte den Datenschutzhinweisen von
          WhatsApp: https://www.whatsapp.com/legal/?eea=1#privacy-policy
        </p>

        <h2>8) Datenverarbeitung zur Bestellabwicklung</h2>

        <p>
          <b>8.1</b>&thinsp;Zur Abwicklung Ihrer Bestellung arbeiten wir mit dem
          / den nachstehenden Dienstleistern zusammen, die uns ganz oder
          teilweise bei der Durchf&uuml;hrung geschlossener Vertr&auml;ge
          unterst&uuml;tzen. An diese Dienstleister werden nach Ma&szlig;gabe
          der folgenden Informationen gewisse personenbezogene Daten
          &uuml;bermittelt.
        </p>

        <p>
          Die von uns erhobenen personenbezogenen Daten werden im Rahmen der
          Vertragsabwicklung an das mit der Lieferung beauftragte
          Transportunternehmen weitergegeben, soweit dies zur Lieferung der Ware
          erforderlich ist. Ihre Zahlungsdaten geben wir im Rahmen der
          Zahlungsabwicklung an das beauftragte Kreditinstitut weiter, sofern
          dies f&uuml;r die Zahlungsabwicklung erforderlich ist. Sofern
          Zahlungsdienstleister eingesetzt werden, informieren wir Sie
          hier&uuml;ber nachstehend explizit. Rechtsgrundlage f&uuml;r die
          Weitergabe der Daten ist Art. 6 Abs. 1 lit. b DSGVO.
        </p>

        <p>
          <b>8.2</b>&thinsp;Verwendung von Paymentdienstleistern
          (Zahlungsdiensten)
        </p>

        <p>
          - Paypal<br />
          Bei Zahlung via PayPal, Kreditkarte via PayPal, Lastschrift via PayPal
          oder &ndash; falls angeboten - &quot;Kauf auf Rechnung&quot; oder
          &bdquo;Ratenzahlung&ldquo; via PayPal geben wir Ihre Zahlungsdaten im
          Rahmen der Zahlungsabwicklung an die PayPal (Europe) S.a.r.l. et Cie,
          S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg (nachfolgend
          &quot;PayPal&quot;), weiter. Die Weitergabe erfolgt gem&auml;&szlig;
          Art. 6 Abs. 1 lit. b DSGVO und nur insoweit, als dies f&uuml;r die
          Zahlungsabwicklung erforderlich ist.<br />
          PayPal beh&auml;lt sich f&uuml;r die Zahlungsmethoden Kreditkarte via
          PayPal, Lastschrift via PayPal oder &ndash; falls angeboten -
          &quot;Kauf auf Rechnung&quot; oder &bdquo;Ratenzahlung&ldquo; via
          PayPal die Durchf&uuml;hrung einer Bonit&auml;tsauskunft vor.
          Hierf&uuml;r werden Ihre Zahlungsdaten gegebenenfalls gem&auml;&szlig;
          Art. 6 Abs. 1 lit. f DSGVO auf Basis des berechtigten Interesses von
          PayPal an der Feststellung Ihrer Zahlungsf&auml;higkeit an
          Auskunfteien weitergegeben. Das Ergebnis der Bonit&auml;tspr&uuml;fung
          in Bezug auf die statistische Zahlungsausfallwahrscheinlichkeit
          verwendet PayPal zum Zweck der Entscheidung &uuml;ber die
          Bereitstellung der jeweiligen Zahlungsmethode. Die
          Bonit&auml;tsauskunft kann Wahrscheinlichkeitswerte enthalten (sog.
          Score-Werte). Soweit Score-Werte in das Ergebnis der
          Bonit&auml;tsauskunft einflie&szlig;en, haben sie ihre Grundlage in
          einem wissenschaftlich anerkannten mathematisch-statistischen
          Verfahren. In die Berechnung der Score-Werte flie&szlig;en unter
          anderem, aber nicht ausschlie&szlig;lich, Anschriftendaten ein.
          Weitere datenschutzrechtliche Informationen, unter anderem zu den
          verwendeten Auskunfteien, entnehmen Sie bitte der
          Datenschutzerkl&auml;rung von PayPal:
          https://www.paypal.com/de/webapps/mpp/ua/privacy-full<br />
          Sie k&ouml;nnen dieser Verarbeitung Ihrer Daten jederzeit durch eine
          Nachricht an PayPal widersprechen. Jedoch bleibt PayPal ggf. weiterhin
          berechtigt, Ihre personenbezogenen Daten zu verarbeiten, sofern dies
          zur vertragsgem&auml;&szlig;en Zahlungsabwicklung erforderlich ist.<br
          />
          - SOFORT<br />
          Bei Auswahl der Zahlungsart &bdquo;SOFORT&ldquo; erfolgt die
          Zahlungsabwicklung &uuml;ber den Zahlungsdienstleister SOFORT GmbH,
          Theresienh&ouml;he 12, 80339 M&uuml;nchen, Deutschland (im Folgenden
          &bdquo;SOFORT&ldquo;), an den wir Ihre im Rahmen des Bestellvorgangs
          mitgeteilten Informationen nebst den Informationen &uuml;ber Ihre
          Bestellung gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO weitergeben.
          Die Sofort GmbH ist Teil der Klarna Group (Klarna Bank AB (publ),
          Sveav&auml;gen 46, 11134 Stockholm, Schweden). Die Weitergabe Ihrer
          Daten erfolgt ausschlie&szlig;lich zum Zweck der Zahlungsabwicklung
          mit dem Zahlungsdienstleister SOFORT und nur insoweit, als sie
          hierf&uuml;r erforderlich ist. Unter der nachstehenden Internetadresse
          erhalten Sie weitere Informationen &uuml;ber die
          Datenschutzbestimmungen von SOFORT:
          https://www.klarna.com/sofort/datenschutz.
        </p>

        <h2>9) Verwendung von Sozialen Medien: Videos</h2>

        <p><b>9.1</b>&thinsp;Verwendung von Vimeo-Videos</p>

        <p>
          Auf unserer Website sind Plugins des Videoportals Vimeo der Vimeo,
          LLC, 555 West 18th Street, New York, New York 10011, USA eingebunden.
          Wenn Sie eine Seite unseres Webauftritts aufrufen, die ein solches
          Plugin enth&auml;lt, stellt Ihr Browser eine direkte Verbindung zu den
          Servern von Vimeo her. Der Inhalt des Plugins wird von Vimeo direkt an
          Ihren Browser &uuml;bermittelt und in die Seite eingebunden. Durch
          diese Einbindung erh&auml;lt Vimeo die Information, dass Ihr Browser
          die entsprechende Seite unseres Webauftritts aufgerufen hat, auch wenn
          Sie keinen Vimeo-Account besitzen oder gerade nicht bei Vimeo
          eingeloggt sind. Diese Information (einschlie&szlig;lich Ihrer
          IP-Adresse) wird von Ihrem Browser direkt an einen Server von Vimeo in
          die USA &uuml;bermittelt und dort gespeichert.<br />
          Sind Sie bei Vimeo eingeloggt, kann Vimeo den Besuch unserer Website
          Ihrem Vimeo-Account unmittelbar zuordnen. Wenn Sie mit den Plugins
          interagieren (wie z.B. Bet&auml;tigung des Start-Buttons eines
          Videos), wird diese Information ebenfalls direkt an einen Server von
          Vimeo &uuml;bermittelt und dort gespeichert.
        </p>

        <p>
          Die beschriebenen Datenverarbeitungsvorg&auml;nge erfolgen
          gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO auf Basis des berechtigten
          Interesses von Vimeo an Marktforschung und der bedarfsgerechten
          Gestaltung des Vimeo-Dienstes.
        </p>

        <p>
          Wenn Sie nicht m&ouml;chten, dass Vimeo die &uuml;ber unseren
          Webauftritt gesammelten Daten unmittelbar Ihrem Vimeo-Account
          zuordnet, m&uuml;ssen Sie sich vor Ihrem Besuch unserer Website bei
          Vimeo ausloggen.
        </p>

        <p>
          Zweck und Umfang der Datenerhebung und die weitere Verarbeitung und
          Nutzung der Daten durch Vimeo sowie Ihre diesbez&uuml;glichen Rechte
          und Einstellungsm&ouml;glichkeiten zum Schutz Ihrer Privatsph&auml;re
          entnehmen Sie bitte den Datenschutzhinweisen von Vimeo:
          https://vimeo.com/privacy
        </p>

        <p>
          Bei Videos von Vimeo, die auf unserer Seite eingebunden sind, ist das
          Trackingtool Google Analytics der Google Ireland Limited, Gordon
          House, 4 Barrow St, Dublin, D04 E5W5, Irland, automatisch integriert.
          Dabei handelt es sich um ein eigenes Tracking von Vimeo, auf das wir
          keinen Zugriff haben und welches von unserer Seite nicht beeinflusst
          werden kann. Google Analytics verwendet f&uuml;r das Tracking sog.
          &bdquo;Cookies&ldquo;, dies sind Textdateien, die auf Ihrem Computer
          gespeichert werden und eine Analyse der Benutzung der Website durch
          Sie erm&ouml;glichen. Die durch das Cookie erzeugten Informationen
          &uuml;ber Ihre Benutzung dieser Website werden in der Regel an einen
          Server von Google &uuml;bertragen und dort gespeichert, hierbei kann
          es auch zu einer &Uuml;bermittlung an die Server der Google LLC. in
          den USA kommen. Alternativ verhindern Sie mit einem Klick auf
          <a
            onclick="alert('Google Analytics wurde deaktiviert');"
            on:click="{gaOptout}"
          >
            diesen Link</a>, dass Google Analytics innerhalb dieser Website
          Daten über Sie erfasst. Mit dem Klick auf obigen Link laden Sie ein
          „Opt-Out-Cookie“ herunter. Ihr Browser muss die Speicherung von
          Cookies also hierzu grundsätzlich erlauben. Löschen Sie Ihre Cookies
          regelmäßig, ist ein erneuter Klick auf den Link bei jedem Besuch
          dieser Website vonnöten.
        </p>

        <p>
          Diese Verarbeitung erfolgt gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO
          auf Grundlage des berechtigten Interesses von Vimeo an der
          statistischen Analyse des Nutzerverhaltens zu Optimierungs- und
          Marketingzwecken.
        </p>

        <p>
          Soweit rechtlich erforderlich, haben wir zur vorstehend dargestellten
          Verarbeitung Ihrer Daten Ihre Einwilligung gem&auml;&szlig; Art. 6
          Abs. 1 lit. a DSGVO eingeholt. Sie k&ouml;nnen Ihre erteilte
          Einwilligung jederzeit mit Wirkung f&uuml;r die Zukunft widerrufen. Um
          Ihren Widerruf auszu&uuml;ben, deaktivieren Sie diesen Dienst im auf
          der Webseite bereitgestellten &quot;Cookie-Consent-Tool&quot;.
        </p>

        <p><b>9.2</b>&thinsp;Verwendung von Youtube-Videos</p>

        <p>
          Diese Website nutzt die Youtube-Einbettungsfunktion zur Anzeige und
          Wiedergabe von Videos des Anbieters &bdquo;Youtube&ldquo;, der zu der
          Google Ireland Limited, Gordon House, 4 Barrow St, Dublin, D04 E5W5,
          Irland (&bdquo;Google&ldquo;) geh&ouml;rt.
        </p>

        <p>
          Hierbei wird der erweiterte Datenschutzmodus verwendet, der nach
          Anbieterangaben eine Speicherung von Nutzerinformationen erst bei
          Wiedergabe des/der Videos in Gang setzt. Wird die Wiedergabe
          eingebetteter Youtube-Videos gestartet, setzt der Anbieter
          &bdquo;Youtube&ldquo; Cookies ein, um Informationen &uuml;ber das
          Nutzerverhalten zu sammeln. Hinweisen von &bdquo;Youtube&ldquo;
          zufolge dienen diese unter anderem dazu, Videostatistiken zu erfassen,
          die Nutzerfreundlichkeit zu verbessern und missbr&auml;uchliche
          Handlungsweisen zu unterbinden. Wenn Sie bei Google eingeloggt sind,
          werden Ihre Daten direkt Ihrem Konto zugeordnet, wenn Sie ein Video
          anklicken. Wenn Sie die Zuordnung mit Ihrem Profil bei YouTube nicht
          w&uuml;nschen, m&uuml;ssen Sie sich vor Aktivierung des Buttons
          ausloggen. Google speichert Ihre Daten (selbst f&uuml;r nicht
          eingeloggte Nutzer) als Nutzungsprofile und wertet diese aus. Eine
          solche Auswertung erfolgt insbesondere gem&auml;&szlig; Art. 6 Abs. 1
          lit. f DSGVO auf Basis der berechtigten Interessen von Google an der
          Einblendung personalisierter Werbung, Marktforschung und/oder
          bedarfsgerechten Gestaltung seiner Website. Ihnen steht ein
          Widerspruchsrecht zu gegen die Bildung dieser Nutzerprofile, wobei Sie
          sich zur Aus&uuml;bung dessen an YouTube richten m&uuml;ssen. Im
          Rahmen der Nutzung von Youtube kann es auch zu einer &Uuml;bermittlung
          von personenbezogenen Daten an die Server der Google LLC. in den USA
          kommen.<br />
          Unabh&auml;ngig von einer Wiedergabe der eingebetteten Videos wird bei
          jedem Aufruf dieser Website eine Verbindung zum Google-Netzwerk
          aufgenommen, was ohne unseren Einfluss weitere
          Datenverarbeitungsvorg&auml;nge ausl&ouml;sen kann.
        </p>

        <p>
          Weitere Informationen zum Datenschutz bei &bdquo;Youtube&ldquo; finden
          Sie in den Youtube-Nutzungsbedingungen unter
          https://www.youtube.com/static?template=terms sowie in der
          Datenschutzerkl&auml;rung von Google unter
          https://www.google.de/intl/de/policies/privacy.
        </p>

        <p>
          Soweit rechtlich erforderlich, haben wir zur vorstehend dargestellten
          Verarbeitung Ihrer Daten Ihre Einwilligung gem&auml;&szlig; Art. 6
          Abs. 1 lit. a DSGVO eingeholt. Sie k&ouml;nnen Ihre erteilte
          Einwilligung jederzeit mit Wirkung f&uuml;r die Zukunft widerrufen. Um
          Ihren Widerruf auszu&uuml;ben, deaktivieren Sie diesen Dienst im auf
          der Webseite bereitgestellten &quot;Cookie-Consent-Tool&quot;.
        </p>

        <h2>10) Webanalysedienste</h2>

        <p>Jetpack (ehemals WordPress.com-Stats)</p>

        <p>
          Dieses Angebot nutzt den Webanalysedienst Jetpack (vormals
          WordPress.com-Stats), der von Automattic Inc., 60 29th Street #343,
          San Francisco, CA 94110-4929, USA, unter Einsatz der
          Trackingtechnologie von Quantcast Inc., 201 3rd St, Floor 2, San
          Francisco, CA 94103-3153, USA betrieben wird. Mithilfe von Jetpack
          werden auf Basis unseres berechtigten Interesses an der statistischen
          Analyse des Nutzerverhaltens zu Optimierungs- und Marketingzwecken
          gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO pseudonymisierte
          Besucherdaten gesammelt, ausgewertet und gespeichert. Aus diesen Daten
          k&ouml;nnen zum selben Zweck pseudonymisierte Nutzungsprofile erstellt
          und ausgewertet werden. Jetpack verwendet sog. Cookies, also kleine
          Textdateien, die lokal im Zwischenspeicher des Internet-Browsers des
          Seitenbesuchers gespeichert werden. Diese Cookies dienen unter anderem
          dazu, den Browser wiederzuerkennen, und erm&ouml;glichen so eine
          genauere Ermittlung der Statistikdaten. Die Daten der IP-Adresse des
          Nutzers werden ebenfalls erhoben, sie werden aber sofort nach der
          Erhebung und vor deren Speicherung pseudonymisiert, um eine
          Personenbeziehbarkeit auszuschlie&szlig;en.
        </p>

        <p>
          Die durch das Cookie erzeugten Informationen &uuml;ber Ihre Benutzung
          dieser Website (einschlie&szlig;lich der pseudonymisierten IP-Adresse)
          werden zur Wahrung der oben genannten Interessen auf einen Server in
          den USA &uuml;bertragen und dort gespeichert.
        </p>

        <p>
          Um einer Datenerhebung und -speicherung Ihrer Besucherdaten f&uuml;r
          die Zukunft zu widersprechen, k&ouml;nnen Sie unter nachfolgendem Link
          ein Opt-Out-Cookie von Quantcast herunterladen, welches bewirkt, dass
          zuk&uuml;nftig keine Besucherdaten Ihres Browsers bei Jetpack erhoben
          und gespeichert werden: https://www.quantcast.com/opt-out
        </p>

        <p>Das Opt-Out-Cookie wird von Quantcast gesetzt.</p>

        <p>
          Soweit rechtlich erforderlich, haben wir zur vorstehend dargestellten
          Verarbeitung Ihrer Daten Ihre Einwilligung gem&auml;&szlig; Art. 6
          Abs. 1 lit. a DSGVO eingeholt. Sie k&ouml;nnen Ihre erteilte
          Einwilligung jederzeit mit Wirkung f&uuml;r die Zukunft widerrufen. Um
          Ihren Widerruf auszu&uuml;ben, befolgen Sie bitte die vorstehend
          geschilderte M&ouml;glichkeit zur Vornahme eines Widerspruchs.
        </p>

        <h2>11) Tools und Sonstiges</h2>

        <p>
          <b>11.1</b>&thinsp;Cookie-Consent-Tool auf Basis der
          Usercentrics-Technologie
        </p>

        <p>
          Diese Webseite nutzt zur Einholung wirksamer Nutzereinwilligungen
          f&uuml;r einwilligungspflichtige Cookies und cookie-basierte
          Anwendungen ein Cookie-Consent-Tool mit Technologie der Usercentrics
          GmbH, Rosental 4, 80331 M&uuml;nchen (nachfolgend
          &bdquo;Usercentrics&ldquo;).
        </p>

        <p>
          Durch Einbindung eines entsprechenden JavaScript-Codes wird Nutzern
          beim Seitenaufruf ein Banner angezeigt, in welchem sich per
          H&auml;kchensetzung Einwilligungen f&uuml;r bestimmte Cookies und/oder
          cookie-basierte Anwendungen erteilen lassen. Hierbei blockiert das
          Tool das Setzen aller einwilligungspflichtigen Cookies solange, bis
          der jeweilige Nutzer entsprechende Einwilligungen per
          H&auml;kchensetzung erteilt. So wird sichergestellt, dass nur im Falle
          einer erteilten Einwilligung derartige Cookies auf dem jeweiligen
          Endger&auml;t des Nutzers gesetzt werden.
        </p>

        <p>
          Damit das Cookie-Consent-Tool Seitenaufrufe individuellen Nutzern
          eindeutig zuordnen und die vom Nutzer getroffenen
          Einwilligungseinstellungen individuell erfassen, protokollieren und
          f&uuml;r eine Sitzungsdauer speichern kann, werden beim Aufruf unserer
          Website durch das Cookie-Consent-Tool bestimmte Nutzerinformationen
          (einschlie&szlig;lich der IP-Adresse) erhoben, an Server von
          Usercentrics &uuml;bermittelt und dort gespeichert.
        </p>

        <p>
          Diese Datenverarbeitungen erfolgen gem&auml;&szlig; Art. 6 Abs. 1 lit.
          f DSGVO auf Basis unseres berechtigten Interesses an einem
          rechtskonformen, nutzerspezifischen und nutzerfreundlichen
          Einwilligungsmanagement f&uuml;r Cookies und mithin an einer
          rechtskonformen Ausgestaltung unseres Internetauftritts.
        </p>

        <p>
          Weitere Rechtsgrundlage f&uuml;r die beschriebenen Datenverarbeitungen
          ist ferner Art. 6 Abs. 1 lit. c DSGVO. Wir unterliegen als
          Verantwortliche der rechtlichen Verpflichtung, den Einsatz technisch
          nicht notwendiger Cookies von der jeweiligen Nutzereinwilligung
          abh&auml;ngig zu machen.
        </p>

        <p>
          Wir haben mit Usercentrics einen Auftragsverarbeitungsvertrag
          abgeschlossen, mit dem wir Usercentrics verpflichten, die Daten von
          Besuchern unserer Website zu sch&uuml;tzen und sie nicht an Dritte
          weiterzugeben.
        </p>

        <p>
          Weitere Informationen zur Datennutzung durch Usercentrics finden Sie
          in der Usercentrics-Datenschutzerkl&auml;rung unter
          https://usercentrics.com/privacy-policy/
        </p>

        <p>
          <b>11.2</b>&thinsp;consentmanager<br />
          Diese Webseite nutzt zur Einholung wirksamer Nutzereinwilligungen
          f&uuml;r einwilligungspflichtige Cookies und cookie-basierte
          Anwendungen das Cookie-Consent-Tool von consentmanager, Jaohawi AB,
          H&aring;ltegelv&auml;gen 1b, 72348 V&auml;ster&aring;s, Schweden
          (&bdquo;consentmanager&ldquo;).<br />
          Durch Einbindung eines entsprechenden JavaScript-Codes wird Nutzern
          beim Seitenaufruf ein Banner angezeigt, in welchem sich per
          H&auml;kchensetzung Einwilligungen f&uuml;r bestimmte Cookies und/oder
          cookie-basierte Anwendungen erteilen lassen. Hierbei blockiert das
          Tool das Setzen aller einwilligungspflichtigen Cookies solange, bis
          der jeweilige Nutzer entsprechende Einwilligungen per
          H&auml;kchensetzung erteilt. So wird sichergestellt, dass nur im Falle
          einer erteilten Einwilligung derartige Cookies auf dem jeweiligen
          Endger&auml;t des Nutzers gesetzt werden.<br />
          Damit das Cookie-Consent-Tool Seitenaufrufe individuellen Nutzern
          eindeutig zuordnen und die vom Nutzer getroffenen
          Einwilligungseinstellungen individuell erfassen, protokollieren und
          f&uuml;r eine Sitzungsdauer speichern kann, werden beim Aufruf unserer
          Website durch das Cookie-Consent-Tool bestimmte Nutzerinformationen
          (einschlie&szlig;lich der IP-Adresse) erhoben, an Server von
          consentmanager &uuml;bermittelt und dort gespeichert.<br />
          Diese Datenverarbeitungen erfolgen gem&auml;&szlig; Art. 6 Abs. 1 lit.
          f DSGVO auf Basis unseres berechtigten Interesses an einem
          rechtskonformen, nutzerspezifischen und nutzerfreundlichen
          Einwilligungsmanagement f&uuml;r Cookies und mithin an einer
          rechtskonformen Ausgestaltung unseres Internetauftritts.<br />
          Weitere Rechtsgrundlage f&uuml;r die beschriebenen Datenverarbeitungen
          ist ferner Art. 6 Abs. 1 lit. c DSGVO. Wir unterliegen als
          Verantwortliche der rechtlichen Verpflichtung, den Einsatz technisch
          nicht notwendiger Cookies von der jeweiligen Nutzereinwilligung
          abh&auml;ngig zu machen.<br />
          Weitere Informationen zur Datennutzung durch consentmanager finden Sie
          in der Datenschutzerkl&auml;rung von consentmanager unter
          https://www.consentmanager.de/privacy.php.
        </p>

        <h2>12) Rechte des Betroffenen</h2>

        <p>
          <b>12.1</b>&thinsp;Das geltende Datenschutzrecht gew&auml;hrt Ihnen
          gegen&uuml;ber dem Verantwortlichen hinsichtlich der Verarbeitung
          Ihrer personenbezogenen Daten umfassende Betroffenenrechte (Auskunfts-
          und Interventionsrechte), &uuml;ber die wir Sie nachstehend
          informieren:
        </p>

        <ul>
          <li>
            Auskunftsrecht gem&auml;&szlig; Art. 15 DSGVO: Sie haben
            insbesondere ein Recht auf Auskunft &uuml;ber Ihre von uns
            verarbeiteten personenbezogenen Daten, die Verarbeitungszwecke, die
            Kategorien der verarbeiteten personenbezogenen Daten, die
            Empf&auml;nger oder Kategorien von Empf&auml;ngern, gegen&uuml;ber
            denen Ihre Daten offengelegt wurden oder werden, die geplante
            Speicherdauer bzw. die Kriterien f&uuml;r die Festlegung der
            Speicherdauer, das Bestehen eines Rechts auf Berichtigung,
            L&ouml;schung, Einschr&auml;nkung der Verarbeitung, Widerspruch
            gegen die Verarbeitung, Beschwerde bei einer Aufsichtsbeh&ouml;rde,
            die Herkunft Ihrer Daten, wenn diese nicht durch uns bei Ihnen
            erhoben wurden, das Bestehen einer automatisierten
            Entscheidungsfindung einschlie&szlig;lich Profiling und ggf.
            aussagekr&auml;ftige Informationen &uuml;ber die involvierte Logik
            und die Sie betreffende Tragweite und die angestrebten Auswirkungen
            einer solchen Verarbeitung, sowie Ihr Recht auf Unterrichtung,
            welche Garantien gem&auml;&szlig; Art. 46 DSGVO bei Weiterleitung
            Ihrer Daten in Drittl&auml;nder bestehen;
          </li>
          <li>
            Recht auf Berichtigung gem&auml;&szlig; Art. 16 DSGVO: Sie haben ein
            Recht auf unverz&uuml;gliche Berichtigung Sie betreffender
            unrichtiger Daten und/oder Vervollst&auml;ndigung Ihrer bei uns
            gespeicherten unvollst&auml;ndigen Daten;
          </li>
          <li>
            Recht auf L&ouml;schung gem&auml;&szlig; Art. 17 DSGVO: Sie haben
            das Recht, die L&ouml;schung Ihrer personenbezogenen Daten bei
            Vorliegen der Voraussetzungen des Art. 17 Abs. 1 DSGVO zu verlangen.
            Dieses Recht besteht jedoch insbesondere dann nicht, wenn die
            Verarbeitung zur Aus&uuml;bung des Rechts auf freie
            Meinungs&auml;u&szlig;erung und Information, zur Erf&uuml;llung
            einer rechtlichen Verpflichtung, aus Gr&uuml;nden des
            &ouml;ffentlichen Interesses oder zur Geltendmachung, Aus&uuml;bung
            oder Verteidigung von Rechtsanspr&uuml;chen erforderlich ist;
          </li>
          <li>
            Recht auf Einschr&auml;nkung der Verarbeitung gem&auml;&szlig; Art.
            18 DSGVO: Sie haben das Recht, die Einschr&auml;nkung der
            Verarbeitung Ihrer personenbezogenen Daten zu verlangen, solange die
            von Ihnen bestrittene Richtigkeit Ihrer Daten &uuml;berpr&uuml;ft
            wird, wenn Sie eine L&ouml;schung Ihrer Daten wegen
            unzul&auml;ssiger Datenverarbeitung ablehnen und stattdessen die
            Einschr&auml;nkung der Verarbeitung Ihrer Daten verlangen, wenn Sie
            Ihre Daten zur Geltendmachung, Aus&uuml;bung oder Verteidigung von
            Rechtsanspr&uuml;chen ben&ouml;tigen, nachdem wir diese Daten nach
            Zweckerreichung nicht mehr ben&ouml;tigen oder wenn Sie Widerspruch
            aus Gr&uuml;nden Ihrer besonderen Situation eingelegt haben, solange
            noch nicht feststeht, ob unsere berechtigten Gr&uuml;nde
            &uuml;berwiegen;
          </li>
          <li>
            Recht auf Unterrichtung gem&auml;&szlig; Art. 19 DSGVO: Haben Sie
            das Recht auf Berichtigung, L&ouml;schung oder Einschr&auml;nkung
            der Verarbeitung gegen&uuml;ber dem Verantwortlichen geltend
            gemacht, ist dieser verpflichtet, allen Empf&auml;ngern, denen die
            Sie betreffenden personenbezogenen Daten offengelegt wurden, diese
            Berichtigung oder L&ouml;schung der Daten oder Einschr&auml;nkung
            der Verarbeitung mitzuteilen, es sei denn, dies erweist sich als
            unm&ouml;glich oder ist mit einem
            unverh&auml;ltnism&auml;&szlig;igen Aufwand verbunden. Ihnen steht
            das Recht zu, &uuml;ber diese Empf&auml;nger unterrichtet zu werden.
          </li>
          <li>
            Recht auf Daten&uuml;bertragbarkeit gem&auml;&szlig; Art. 20 DSGVO:
            Sie haben das Recht, Ihre personenbezogenen Daten, die Sie uns
            bereitgestellt haben, in einem strukturierten, g&auml;ngigen und
            maschinenlesebaren Format zu erhalten oder die &Uuml;bermittlung an
            einen anderen Verantwortlichen zu verlangen, soweit dies technisch
            machbar ist;
          </li>
          <li>
            Recht auf Widerruf erteilter Einwilligungen gem&auml;&szlig; Art. 7
            Abs. 3 DSGVO: Sie haben das Recht, eine einmal erteilte Einwilligung
            in die Verarbeitung von Daten jederzeit mit Wirkung f&uuml;r die
            Zukunft zu widerrufen. Im Falle des Widerrufs werden wir die
            betroffenen Daten unverz&uuml;glich l&ouml;schen, sofern eine
            weitere Verarbeitung nicht auf eine Rechtsgrundlage zur
            einwilligungslosen Verarbeitung gest&uuml;tzt werden kann. Durch den
            Widerruf der Einwilligung wird die Rechtm&auml;&szlig;igkeit der
            aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung
            nicht ber&uuml;hrt;
          </li>
          <li>
            Recht auf Beschwerde gem&auml;&szlig; Art. 77 DSGVO: Wenn Sie der
            Ansicht sind, dass die Verarbeitung der Sie betreffenden
            personenbezogenen Daten gegen die DSGVO verst&ouml;&szlig;t, haben
            Sie - unbeschadet eines anderweitigen verwaltungsrechtlichen oder
            gerichtlichen Rechtsbehelfs - das Recht auf Beschwerde bei einer
            Aufsichtsbeh&ouml;rde, insbesondere in dem Mitgliedstaat Ihres
            Aufenthaltsortes, Ihres Arbeitsplatzes oder des Ortes des
            mutma&szlig;lichen Versto&szlig;es.
          </li>
        </ul>

        <p><b>12.2</b>&thinsp;WIDERSPRUCHSRECHT</p>

        <p>
          WENN WIR IM RAHMEN EINER INTERESSENABW&Auml;GUNG IHRE
          PERSONENBEZOGENEN DATEN AUFGRUND UNSERES &Uuml;BERWIEGENDEN
          BERECHTIGTEN INTERESSES VERARBEITEN, HABEN SIE DAS JEDERZEITIGE RECHT,
          AUS GR&Uuml;NDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN,
          GEGEN DIESE VERARBEITUNG WIDERSPRUCH MIT WIRKUNG F&Uuml;R DIE ZUKUNFT
          EINZULEGEN.<br />
          MACHEN SIE VON IHREM WIDERSPRUCHSRECHT GEBRAUCH, BEENDEN WIR DIE
          VERARBEITUNG DER BETROFFENEN DATEN. EINE WEITERVERARBEITUNG BLEIBT
          ABER VORBEHALTEN, WENN WIR ZWINGENDE SCHUTZW&Uuml;RDIGE GR&Uuml;NDE
          F&Uuml;R DIE VERARBEITUNG NACHWEISEN K&Ouml;NNEN, DIE IHRE INTERESSEN,
          GRUNDRECHTE UND GRUNDFREIHEITEN &Uuml;BERWIEGEN, ODER WENN DIE
          VERARBEITUNG DER GELTENDMACHUNG, AUS&Uuml;BUNG ODER VERTEIDIGUNG VON
          RECHTSANSPR&Uuml;CHEN DIENT.
        </p>

        <p>
          WERDEN IHRE PERSONENBEZOGENEN DATEN VON UNS VERARBEITET, UM
          DIREKTWERBUNG ZU BETREIBEN, HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH
          GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM
          ZWECKE DERARTIGER WERBUNG EINZULEGEN. SIE K&Ouml;NNEN DEN WIDERSPRUCH
          WIE OBEN BESCHRIEBEN AUS&Uuml;BEN.
        </p>

        <p>
          MACHEN SIE VON IHREM WIDERSPRUCHSRECHT GEBRAUCH, BEENDEN WIR DIE
          VERARBEITUNG DER BETROFFENEN DATEN ZU DIREKTWERBEZWECKEN.
        </p>

        <h2>13) Dauer der Speicherung personenbezogener Daten</h2>

        <p>
          Die Dauer der Speicherung von personenbezogenen Daten bemisst sich
          anhand der jeweiligen Rechtsgrundlage, am Verarbeitungszweck und
          &ndash; sofern einschl&auml;gig &ndash; zus&auml;tzlich anhand der
          jeweiligen gesetzlichen Aufbewahrungsfrist (z.B. handels- und
          steuerrechtliche Aufbewahrungsfristen).
        </p>

        <p>
          Bei der Verarbeitung von personenbezogenen Daten auf Grundlage einer
          ausdr&uuml;cklichen Einwilligung gem&auml;&szlig; Art. 6 Abs. 1 lit. a
          DSGVO werden diese Daten so lange gespeichert, bis der Betroffene
          seine Einwilligung widerruft.
        </p>

        <p>
          Existieren gesetzliche Aufbewahrungsfristen f&uuml;r Daten, die im
          Rahmen rechtsgesch&auml;ftlicher bzw.
          rechtsgesch&auml;fts&auml;hnlicher Verpflichtungen auf der Grundlage
          von Art. 6 Abs. 1 lit. b DSGVO verarbeitet werden, werden diese Daten
          nach Ablauf der Aufbewahrungsfristen routinem&auml;&szlig;ig
          gel&ouml;scht, sofern sie nicht mehr zur Vertragserf&uuml;llung oder
          Vertragsanbahnung erforderlich sind und/oder unsererseits kein
          berechtigtes Interesse an der Weiterspeicherung fortbesteht.
        </p>

        <p>
          Bei der Verarbeitung von personenbezogenen Daten auf Grundlage von
          Art. 6 Abs. 1 lit. f DSGVO werden diese Daten so lange gespeichert,
          bis der Betroffene sein Widerspruchsrecht nach Art. 21 Abs. 1 DSGVO
          aus&uuml;bt, es sei denn, wir k&ouml;nnen zwingende schutzw&uuml;rdige
          Gr&uuml;nde f&uuml;r die Verarbeitung nachweisen, die die Interessen,
          Rechte und Freiheiten der betroffenen Person &uuml;berwiegen, oder die
          Verarbeitung dient der Geltendmachung, Aus&uuml;bung oder Verteidigung
          von Rechtsanspr&uuml;chen.
        </p>

        <p>
          Bei der Verarbeitung von personenbezogenen Daten zum Zwecke der
          Direktwerbung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO werden
          diese Daten so lange gespeichert, bis der Betroffene sein
          Widerspruchsrecht nach Art. 21 Abs. 2 DSGVO aus&uuml;bt.
        </p>

        <p>
          Sofern sich aus den sonstigen Informationen dieser Erkl&auml;rung
          &uuml;ber spezifische Verarbeitungssituationen nichts anderes ergibt,
          werden gespeicherte personenbezogene Daten im &Uuml;brigen dann
          gel&ouml;scht, wenn sie f&uuml;r die Zwecke, f&uuml;r die sie erhoben
          oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig sind.
        </p>
      </div>
      <a class="button is-outlined" on:click="{() => history.back()}">Zurück</a>
    </div>
  </div>
</div>

<script>
import { push } from "svelte-spa-router";
import { gaProperty } from "./constants";
import GlobalNav from "./GlobalNav.svelte";
import Heading from "./Heading.svelte";

const disableStr = "ga-disable-" + gaProperty;
if (document.cookie.indexOf(disableStr + "=true") > -1) {
  window[disableStr] = true;
}
function gaOptout() {
  document.cookie =
    disableStr + "=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/";
  window[disableStr] = true;
}
</script>

<style type="text/scss">
.box {
  margin-top: 5rem;
}
</style>
